import { radius4 } from 'core/styles'

// Local layout constant (component token): the raised segment sits inside the
// track, so its radius is one step tighter than radiusInput
export const segmentRadius = radius4
